import PQueue from 'p-queue';
import { NUDGE_PROCESSING_QUEUE_MAX_SIZE } from '../constants';

export class NudgeProcessingQueue {
    queue: PQueue = new PQueue({ concurrency: 1, autoStart: false });

    start() {
        this.queue.start();
    }

    pause() {
        this.queue.pause();
    }

    clear() {
        this.queue.clear();
    }

    add(nudgeProcessor: () => Promise<void>) {
        if (this.queue.size < NUDGE_PROCESSING_QUEUE_MAX_SIZE) {
            this.queue.add(nudgeProcessor);
        }
    }

    get isFull() {
        return this.queue.size >= NUDGE_PROCESSING_QUEUE_MAX_SIZE;
    }
}
